var map = {
	"./X33-Mall_small.jpg": 915,
	"./all.svg": 916,
	"./apple-watch.png": 917,
	"./b-headphone.png": 918,
	"./coin.svg": 919,
	"./delete-btn.svg": 920,
	"./iphone-pink.png": 921,
	"./love.svg": 922,
	"./mall-banner-cn.jpg": 923,
	"./mall-banner-id.jpg": 924,
	"./mall-banner-ms.jpg": 925,
	"./mall-banner.jpg": 926,
	"./mobile-bg.jpg": 927,
	"./price-high.svg": 928,
	"./price-low.svg": 929,
	"./shopping-cart.svg": 930,
	"./star.svg": 931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;